/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './tickets.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from './ticket/ticket.component.ngfactory';
import * as i3 from '../../../../../app/shared/components/tickets/ticket/ticket.component';
import * as i4 from '../../../../../app/core/services/common-api.service';
import * as i5 from '../../../../../app/core/services/global-app-state.service';
import * as i6 from 'ngx-bootstrap/popover/popover.directive';
import * as i7 from 'ngx-bootstrap/popover/popover.config';
import * as i8 from 'ngx-bootstrap/component-loader/component-loader.factory';
import * as i9 from '@angular/common';
import * as i10 from './new-ticket-modal/new-ticket-modal.component.ngfactory';
import * as i11 from '../../../../../app/shared/components/tickets/new-ticket-modal/new-ticket-modal.component';
import * as i12 from '../../../../../app/shared/components/tickets/tickets.component';
import * as i13 from 'ngx-toastr';
const styles_TicketsComponent:any[] = [i0.styles];
export const RenderType_TicketsComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_TicketsComponent,data:{}});
function View_TicketsComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,'li',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted(-1,(null as any),['\n        '])),(_l()(),i1.ɵeld(2,0,(null as any),
      (null as any),1,'re-ticket',([] as any[]),(null as any),[[(null as any),'resolve']],
      (_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('resolve' === en)) {
          const pd_0:any = ((<any>_co.onTicketResolve(_v.context.index)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i2.View_TicketComponent_0,i2.RenderType_TicketComponent)),i1.ɵdid(3,245760,
      (null as any),0,i3.TicketComponent,[i4.CommonApiService,i5.GlobalAppStateService],
      {ticket:[0,'ticket']},{resolve:'resolve'}),(_l()(),i1.ɵted(-1,(null as any),
      ['\n      ']))],(_ck,_v) => {
    const currVal_0:any = _v.context.$implicit;
    _ck(_v,3,0,currVal_0);
  },(null as any));
}
function View_TicketsComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),5,'li',[['class',
      'more-btn-container']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n        '])),(_l()(),i1.ɵeld(2,
      16777216,(null as any),(null as any),2,'button',[['class','btn navbar-btn'],
          ['placement','bottom']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),i1.ɵdid(3,212992,(null as any),0,i6.PopoverDirective,[i1.ElementRef,
      i1.Renderer2,i1.ViewContainerRef,i7.PopoverConfig,i8.ComponentLoaderFactory],
      {popover:[0,'popover'],placement:[1,'placement']},(null as any)),(_l()(),i1.ɵted(-1,
      (null as any),['more...'])),(_l()(),i1.ɵted(-1,(null as any),['\n      ']))],
      (_ck,_v) => {
        const currVal_0:any = i1.ɵnov((<any>_v.parent),18);
        const currVal_1:any = 'bottom';
        _ck(_v,3,0,currVal_0,currVal_1);
      },(null as any));
}
function View_TicketsComponent_5(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,'li',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted(-1,(null as any),['\n        '])),(_l()(),i1.ɵeld(2,0,(null as any),
      (null as any),1,'re-ticket',([] as any[]),(null as any),[[(null as any),'resolve']],
      (_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('resolve' === en)) {
          const pd_0:any = ((<any>_co.onTicketResolve((_v.context.index + _co.displayLimit))) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i2.View_TicketComponent_0,i2.RenderType_TicketComponent)),i1.ɵdid(3,245760,
      (null as any),0,i3.TicketComponent,[i4.CommonApiService,i5.GlobalAppStateService],
      {ticket:[0,'ticket']},{resolve:'resolve'}),(_l()(),i1.ɵted(-1,(null as any),
      ['\n      ']))],(_ck,_v) => {
    const currVal_0:any = _v.context.$implicit;
    _ck(_v,3,0,currVal_0);
  },(null as any));
}
function View_TicketsComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(1,
      0,(null as any),(null as any),5,'ul',[['class','more']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
      ['\n      '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),2,(null as any),
      View_TicketsComponent_5)),i1.ɵdid(4,802816,(null as any),0,i9.NgForOf,[i1.ViewContainerRef,
      i1.TemplateRef,i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),i1.ɵpid(0,
      i9.SlicePipe,([] as any[])),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),
      i1.ɵted(-1,(null as any),['\n  ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = i1.ɵunv(_v,4,0,i1.ɵnov(_v,5).transform(_co.tickets,_co.displayLimit));
    _ck(_v,4,0,currVal_0);
  },(null as any));
}
function View_TicketsComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),25,(null as any),
      (null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(2,0,(null as any),
          (null as any),14,'div',([] as any[]),(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵeld(4,0,(null as any),(null as any),8,'ul',[['class','display col-md-8']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n      '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),2,(null as any),View_TicketsComponent_2)),i1.ɵdid(7,802816,
          (null as any),0,i9.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,i1.IterableDiffers],
          {ngForOf:[0,'ngForOf']},(null as any)),i1.ɵpid(0,i9.SlicePipe,([] as any[])),
      (_l()(),i1.ɵted(-1,(null as any),['\n      '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_TicketsComponent_3)),i1.ɵdid(11,16384,
          (null as any),0,i9.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵted(-1,
          (null as any),['\n    '])),(_l()(),i1.ɵeld(14,0,(null as any),(null as any),
          1,'button',[['class','btn btn-default navbar-btn new-ticket']],(null as any),
          [[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,23).show()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['New Ticket'])),
      (_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n\n  '])),(_l()(),i1.ɵand(0,[['moreTicketsTemplate',2]],(null as any),
          0,(null as any),View_TicketsComponent_4)),(_l()(),i1.ɵted(-1,(null as any),
          ['\n  '])),(_l()(),i1.ɵeld(20,0,(null as any),(null as any),4,'div',[['class',
          'col-md-4']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(22,0,(null as any),
          (null as any),1,'re-new-ticket-modal',([] as any[]),(null as any),[[(null as any),
              'create']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('create' === en)) {
              const pd_0:any = ((<any>_co.onTicketCreate($event)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i10.View_NewTicketModalComponent_0,i10.RenderType_NewTicketModalComponent)),
      i1.ɵdid(23,245760,[['newTicketModal',4]],0,i11.NewTicketModalComponent,[i4.CommonApiService,
          i5.GlobalAppStateService],(null as any),{create:'create'}),(_l()(),i1.ɵted(-1,
          (null as any),['\n  '])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,
      _v) => {
    var _co:any = _v.component;
    const currVal_0:any = i1.ɵunv(_v,7,0,i1.ɵnov(_v,8).transform(_co.tickets,0,_co.displayLimit));
    _ck(_v,7,0,currVal_0);
    const currVal_1:any = (_co.tickets.length > _co.displayLimit);
    _ck(_v,11,0,currVal_1);
    _ck(_v,23,0);
  },(null as any));
}
export function View_TicketsComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(2,[(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_TicketsComponent_1)),i1.ɵdid(1,16384,(null as any),0,i9.NgIf,[i1.ViewContainerRef,
      i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any))],(_ck,_v) => {
    var _co:i12.TicketsComponent = _v.component;
    const currVal_0:any = _co.tickets;
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
export function View_TicketsComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'re-tickets',
      ([] as any[]),(null as any),(null as any),(null as any),View_TicketsComponent_0,
      RenderType_TicketsComponent)),i1.ɵdid(1,245760,(null as any),0,i12.TicketsComponent,
      [i4.CommonApiService,i5.GlobalAppStateService,i13.ToastrService,i1.ChangeDetectorRef],
      (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const TicketsComponentNgFactory:i1.ComponentFactory<i12.TicketsComponent> = i1.ɵccf('re-tickets',
    i12.TicketsComponent,View_TicketsComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /home/travis/build/inspirehep/record-editor/src/$$_gendir/app/shared/components/tickets/tickets.component.ngfactory.ts